import { SortingMode, TagGroupBy } from 'shared/types/sorting-mode';
import { NewTagWithID } from 'shared/types/tag';
import * as yup from 'yup';

const schema = yup
  .object<NewTagWithID>({
    id: yup.string().required(),
    name: yup.string().required(),
    color: yup.string().nullable(),
    taskSorting: yup.array().of(yup.string().required()).nullable(),
    taskGroupBy: yup.string().oneOf(Object.values(TagGroupBy)).nullable(),
    taskSortingMode: yup.string().oneOf(Object.values(SortingMode)).nullable(),
  })
  .strip();

const arraySchema = yup.array().of(schema);

export const newTagsValidation = (tags: NewTagWithID[]) =>
  arraySchema.validateSync(tags, { stripUnknown: true }) as
    | NewTagWithID[]
    | undefined;
